import React, { useState } from 'react';
import Link from 'next/link';
import moment from 'moment';
import { DownChevronIcon, SearchIcon } from '../../modules/Icons';

const BlogNavigation: React.FC<any> = (props) => {
  const { activeCategory, categories, searchQuery } = props;
  const [hoveredCategoryId, setHoveredCategoryId] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  return (
    <>
      <div className="flex flex-col md:flex-row justify-center items-center h-[72px] bg-gray-800 text-white inter uppercase text-[12px] md:text-[14px] gap-2 lg:gap-4 xl:gap-8">
        {/* MOBILE MENU */}
        <div className="block md:hidden">
          <button
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            className={`block md:hidden uppercase`}>
            {activeCategory?.title || 'All Categories'}{' '}
            <DownChevronIcon
              className={`inline ml-1.5 scale-[1.2] stroke-white ${mobileMenuOpen && 'rotate-180'}`}
            />
          </button>

          {mobileMenuOpen && (
            <div className="z-[99] fixed left-0 flex flex-col items-center text-center bg-gray-800 gap-3 py-8 w-full">
              <a href="/blog" className={`${!activeCategory?.slug ? 'text-a-blue' : ''}`}>
                All
              </a>
              {categories.map((category, k) => (
                <a
                  href={`/blog?category=${category.slug}`}
                  key={k}
                  className={`${
                    activeCategory?.slug == category.slug ? 'text-a-blue' : 'hover:text-a-blue'
                  }`}>
                  {category.title}
                </a>
              ))}
            </div>
          )}
        </div>
        {/* END MOBILE MENU */}

        <a
          href="/blog"
          className={`hidden md:block md:pl-2 lg:pl-4 ${
            activeCategory?.slug == null ? 'text-a-blue' : ''
          }`}>
          All
        </a>
        {categories.map((category, k) => (
          <div
            key={k}
            onMouseEnter={() => setHoveredCategoryId(category.id)}
            onMouseLeave={() => setHoveredCategoryId(null)}
            className="relative hidden md:block">
            <a
              href={`/blog?category=${category.slug}`}
              key={k}
              className={`${
                activeCategory?.slug == category.slug ? 'text-a-blue' : 'hover:text-a-blue'
              }`}>
              {category.title}
            </a>
            {hoveredCategoryId == category.id && category?.children?.length > 0 && (
              <div className="absolute flex flex-col gap-3 bg-gray-800 z-[99] w-[200px] p-4">
                {category?.children?.map((child, k) => (
                  <a
                    href={`/blog?category=${child.slug}`}
                    key={k}
                    className={`${
                      activeCategory?.slug == child.slug ? 'text-a-blue' : ' hover:text-a-blue'
                    }`}>
                    {child.title}
                  </a>
                ))}
              </div>
            )}
          </div>
        ))}

        <div className="hidden md:flex rounded-[5px] bg-gray-900 px-2 py-1 lg:w-[360px] md:mr-2 lg:mr-4">
          <SearchIcon className="inline w-4 mr-2 stroke-white-60" />
          <input
            type="search"
            placeholder={searchQuery || 'Blog Search'}
            className="px-1 bg-transparent outline-none"
            onKeyDown={(e) => {
              const target = e.target as HTMLInputElement;
              if (e.keyCode == 13) {
                window.location.href = `/blog?q=${target.value}`;
              }
            }}
          />
        </div>
      </div>

      <div className="block md:hidden rounded-[5px] bg-gray-900 px-2 py-2 md:w-[360px]">
        <SearchIcon className="inline w-4 mr-2 stroke-white" />
        <input
          type="search"
          placeholder={searchQuery || 'Blog Search'}
          className="bg-transparent px-1 outline-none text-[13px]"
          onKeyDown={(e) => {
            const target = e.target as HTMLInputElement;
            if (e.keyCode == 13) {
              window.location.href = `/blog?q=${target.value}`;
            }
          }}
        />
      </div>
    </>
  );
};

export default BlogNavigation;
